export const selectSignupLoading = state => state.signup.loading;
export const selectGeneralFormError = state => state.signup.generalFormError;
export const selectOwnerOrSitterFormError =
  state => state.signup.sitterOrOwnerFormError;
